type StylesTypes = { readonly [key: string]: string };

export default function getThemeStyles(styles: StylesTypes, customThemeStyles?: Record<string, unknown>): Record<string, unknown> {
    const themeStyles = process.env.NEXT_PUBLIC_WEBSITE_BRAND === "kinodk" ? {
        "themedk": true,
        [styles.ThemeDk]: true
    } : {
        "themefw": true,
        [styles.ThemeFw]: true
    };

    return { ...themeStyles, ...customThemeStyles };
}